import { render, staticRenderFns } from "./CreateStudentGroup.vue?vue&type=template&id=dd7c38b6&scoped=true"
import script from "./CreateStudentGroup.vue?vue&type=script&lang=js"
export * from "./CreateStudentGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateStudentGroup.vue?vue&type=style&index=0&id=dd7c38b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7c38b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd7c38b6')) {
      api.createRecord('dd7c38b6', component.options)
    } else {
      api.reload('dd7c38b6', component.options)
    }
    module.hot.accept("./CreateStudentGroup.vue?vue&type=template&id=dd7c38b6&scoped=true", function () {
      api.rerender('dd7c38b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/CreateStudentGroup.vue"
export default component.exports